import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import {
  isInstallmentsPrice,
  isOneTimePrice,
} from "@circle-react/helpers/paywallPriceHelpers";
import type { Paywall } from "@circle-react/types";
import type { PaywallPrice } from "@circle-react/types/PaywallPrice";
import { defaultFormatPaywallCurrency } from "../constants";
import type { PriceScenariosProps } from "../types";
import { Title } from "./Title";

const getTitle = (price: PaywallPrice, paywall: Paywall) => {
  if (isOneTimePrice(price)) {
    return {
      title: formatPaywallCurrencyAmount(
        paywall.currency,
        price.amount,
        defaultFormatPaywallCurrency,
      ),
    };
  }

  if (isInstallmentsPrice(price)) {
    return {
      prefix: `${price.installments_count}x`,
      title: formatPaywallCurrencyAmount(
        paywall.currency,
        Math.floor(
          (price.amount - (price.upfront_payment_amount || 0)) /
            (price.installments_count || 1),
        ),
        defaultFormatPaywallCurrency,
      ),
      suffix: `/${t(["paywall_checkout.price_value.interval_suffix", price.interval_type])}`,
    };
  }

  return {
    title: formatPaywallCurrencyAmount(
      paywall.currency,
      price.amount,
      defaultFormatPaywallCurrency,
    ),
    suffix: `/${t(["paywall_checkout.price_value.interval_suffix", price.interval_type])}`,
  };
};

export const Value = ({ price, paywall }: PriceScenariosProps) => (
  <Title {...getTitle(price, paywall)} />
);
